import { modules } from "../../../stores/AppConfig";
import { exchangeRates } from "../../../stores/AppStatus";
import { get as getValue } from 'svelte/store';

// Determine if the ACTION (insert, edit, delete) is enabled in the MODULE when the week has status WEEKSTATUS
export const isActionEnabled = (tab, action, weekStatus) => {
//console.log("================= isActionEnabled ==============", tab, action, weekStatus);
var modls = getValue(modules);
//console.log({ tab });
//console.log({ action });
//console.log({ weekStatus });
//console.log({ modls });
try {
    const module = modls.find(m => m.name === tab);
    if (module) {
        const statusArray = module[action + 'Statuses'];
        if (statusArray) {
            return statusArray.map(status => status.trim()).includes(weekStatus.trim());
        }
    }
    //console.error(`isActionEnabled() - No matching action/status found for given role tab: ${tab}, action: ${action}`);
    return false;
} catch (err) {
    console.error(`isActionEnabled() - failed for tab: ${tab}, action: ${action}, weekStatus: ${weekStatus}`, err);
    return false;
}
};

export function isDateValueToCheck(value) {
    console.log("================= isDateValueToCheck ==============");
    return value !== null && value !== '' && !isNaN(value);
}

export function excelDateToDate(serial) {
    console.log("================= excelDateToDate ==============");
    const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // Excel leap year bug
    const millisecondsPerDay = 86400000;
    return new Date(excelEpoch.getTime() + serial * millisecondsPerDay);
}

export function formatDate(date) {
    console.log("================= formatDate ==============");
    return date.toISOString().split('T')[0]; // "YYYY-MM-DD"
}

export function formatDateTime(date) {
    console.log("================= formatDate ==============");
    return date.toISOString().split('.')[0]; // "YYYY-MM-DDTHH24:MI:SS"
}

export function validateDateField(date, fieldName, weekStart, weekEnd) {
    console.log("================= validateDateField ==============");
    console.log(date);
    if (!(date instanceof Date && !isNaN(date))) {
        return { priority: 9, message: `${fieldName}_must_be_date`, field: fieldName, type: 'E' };
    }
    if (weekStart && weekEnd) {
        weekStart = new Date(weekStart);
        weekEnd = new Date(weekEnd);
        if (date < weekStart || date > weekEnd) {
            return { priority: 9, message: `${fieldName}_out_of_week`, field: fieldName, type: 'E' };
        }
    }
    return null;
}

export const formatVolume = (val) => {
    var locale = navigator.language || 'en-US';
    var priceNumberFormat = new Intl.NumberFormat(locale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        useGrouping: true
                    });
    return (val != Math.round(val))? (val ? priceNumberFormat.format(+(Math.round(val + "e+2")  + "e-2")) : ''): String(val);
}

export const formatPrice = (val) => {
    var locale = navigator.language || 'en-US';
    var priceNumberFormat = new Intl.NumberFormat(locale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                        useGrouping: true
                    });
    return (val != Math.round(val))? (val ? priceNumberFormat.format(+(Math.round(val + "e+2")  + "e-2")) : ''): String(val);
}

export const isNumber = (value) => {
    if (typeof value == "string") {
        value = value.replace(',','.');
    }

    return Number.isFinite(+value);
}

export const isWholeNumber = (value) => {
    if (isNumber(value)) {
        if (value == Math.round(value)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const convertToEur = (value, currency) => {
let retValue = null;

    if (currency && value) {
    currency = String(currency).toUpperCase();
    if (currency == "EUR") {
        retValue = value;
    } else {
        let exRate = getValue(exchangeRates).filter((x) => x.code == currency).at(0)?.valueInEur;
        console.log(exRate);
        if (exRate && exRate > 0) {
        retValue = (value / exRate).toFixed(3);
        }
    }
    }
    return Number(retValue);
};


export const capitalize = ([ first, ...rest ]) => first.toUpperCase() + rest.join('').toLowerCase();


export const inRange = (value,first,last) => {

    let lower = Math.min(first,last), upper = Math.max(first,last);
    return value >= lower && value <= upper ;
   
   }


   // Function to get unique buyers
export function getUniqueBuyers(item) {
     // Check if buyerDetails array exists and is not empty
     if (!item.buyerDetails || item.buyerDetails.length === 0) {
       return [];
     }
 
     // Use Map to get unique buyers by uuid
     const uniqueBuyersMap = new Map();
     item.buyerDetails.forEach((buyer) => {
       if (!uniqueBuyersMap.has(buyer.uuid)) {
         uniqueBuyersMap.set(buyer.uuid, buyer);
       }
     });
 
     // Sort by full name (lastName + firstName)
     return Array.from(uniqueBuyersMap.values()).sort((a, b) => {
       const nameA = `${a.lastName} ${a.firstName}`.toLowerCase();
       const nameB = `${b.lastName} ${b.firstName}`.toLowerCase();
       return nameA.localeCompare(nameB);
     });
}
 